import React, { useState } from "react"
import { useDispatch } from "react-redux"
import { updateIDPSettings } from "reduxSlices/SAMLConfigurationsSlice"
import { SAMLConfigurationShape } from "utils/propTypeShapes"
import { PrimaryButton } from "../buttons"
import SAMLConfigurationsListItemSection from "./SAMLConfigurationsListItemSection"

const SAMLConfigurationsListItemMetadataSection = ({ configuration }) => {
  const dispatch = useDispatch()
  const [file, setFile] = useState()
  const { id } = configuration

  const changeFile = (event) => {
    setFile(event.target.files[0])
  }

  const update = (event) => {
    event.preventDefault()

    if (!file) return

    dispatch(updateIDPSettings({ id, idpMetadataFile: file }))
    event.target.reset()
    setFile(null)
  }

  const formId = `update-idp-settings-form-${id}`

  return (
    <SAMLConfigurationsListItemSection title="Identity Provider Metadata">
      <div className="flex flex-col gap-8 sm:gap-4 w-full">
        <form id={formId} className="flex flex-col sm:flex-row gap-4 w-full min-w-0" onSubmit={update}>
          <input
            accept=".xml, text/xml, application/xml"
            className="grow file-input min-w-0 file:bg-white"
            onChange={changeFile}
            type="file"
          />
          <PrimaryButton
            disabled={!file}
            form={formId}
            text="Upload"
            type="submit"
          />
        </form>
        <p className="text-xs text-dark">
          Upload a new metadata file to update the SAML configuration.
        </p>
      </div>
    </SAMLConfigurationsListItemSection>
  )
}

SAMLConfigurationsListItemMetadataSection.propTypes = {
  configuration: SAMLConfigurationShape.isRequired,
}

export default SAMLConfigurationsListItemMetadataSection
